import { Page } from "../../types/pageTypes";
import ForecastDetailsComponent from './ForecastDetailsComponent';

export const page: Page = {
    title: 'Forecast Analysis Graph',
    icon: 'chart-area',
    component: ForecastDetailsComponent,
    path: '/graph'
};
